import { FeatureFlagsStore } from 'stores'

import { ZaiNativeSideChat } from '../zai-native-side-chat'
import { ZaiSideChatIframe } from '../zai-side-chat-iframe'

export const ZaiSideChat = () => {
  const isNativeZaiChatEnabled = FeatureFlagsStore.getFeatureFlag('isNativeZaiChatEnabled')

  if (isNativeZaiChatEnabled) {
    return <ZaiNativeSideChat />
  }

  return <ZaiSideChatIframe />
}
